import { createContext } from 'react';

const FormElementContext = /*#__PURE__*/createContext({});

export { FormElementContext as F };
//# sourceMappingURL=FormElementContext-pUV2tgYQ.js.map
